import React, { useContext } from 'react';
import { Grid, TextField, Button } from '@mui/material';
import { SearchOutlined as SearchIcon, Add as AddIcon } from '@mui/icons-material';
import { shipmentTypesContext } from '../ShipmentTypesContext';
import { Link } from 'react-router-dom';


let Filters = () => {
    let service = useContext(shipmentTypesContext);
    return (
        <>
            <Grid item xs={2}>
                <TextField
                    fullWidth
                    size="small"
                    placeholder="Search"
                    value={service.search.fullText}
                    onChange={(e: any) => service.updateSearch({
                        ...service.search,
                        fullText: e.target.value
                    })}
                />
            </Grid>
            <Grid item>
                <Button
                    type="submit"
                    variant="outlined"
                    aria-label="search"
                    onClick={() => service.doSearch(service.search)}
                >
                    <SearchIcon />
                </Button>
            </Grid>
            <Grid item xs />
            <Grid item>
                <Button
                    variant="contained"
                    color='inherit'
                    component={Link}
                    to={'/admin/shipmenttype/addnew'}
                >
                    <AddIcon />&nbsp;Add New
                </Button>
            </Grid>
        </>
    );
}

export default Filters;